var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('el-aside',{staticClass:"menu",style:({ width: _vm.isCollapse == true ? '80px' : '240px' })},[_c('sidebarNav')],1),_c('mainContent',{staticClass:"content",style:({
      marginLeft: _vm.isCollapse == true ? '80px' : '240px',
      width: _vm.isCollapse == true ? 'calc(100% - 80px)' : 'calc(100% - 240px)',
    })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }